{
  "de": {
    "issue_list": {
      "actions": {
        "add_units": "Einheiten",
        "change_responsible": "Verantwortlichen ändern",
        "check": "Prüfen",
        "create_issue_lists": "Punkteliste erstellen | Punktelisten erstellen",
        "delete": "Löschen",
        "delete_count": "Sie sind dabei, Punkte für {count} Einheit zu löschen. Sind Sie sicher? | Sie sind dabei, Punkte für {count} Einheiten zu löschen. Sind Sie sicher?",
        "delete_issue_lists": "Punkte löschen",
        "edit": "Bearbeiten",
        "edit_issue_list": "Art der Punkteliste bearbeiten",
        "export": "Exportieren",
        "generatePDF": "PDF erstellen",
        "go_to_summary": "Zur Zusammenfassung gehen",
        "new": "Punkt",
        "new_customer": "Punkt melden",
        "new_issue_list": "Punkteliste",
        "selectAll": "Alle {total} Listen auswählen",
        "unSelectAll": "Auswahl aufheben",
        "update": "Aktualisieren"
      },
      "attributes": {
        "date": "Startdatum",
        "description": "Beschreibung",
        "name": "Name"
      },
      "labels": {
        "aftercare_conversations": "Nachbetreuungskonversationen",
        "aftercare_conversations_go_to_settings": "Zu den Einstellungen gehen",
        "aftercare_conversations_not_enabled": "Konversationen innerhalb der Nachbetreuung sind noch nicht aktiviert. Sie können sie in den Organisationseinstellungen aktivieren.",
        "aftercare_conversations_toggle": "Konversationen innerhalb der Nachbetreuung aktivieren",
        "assign_to_list": "Liste zuweisen",
        "collapse_all": "Einklappen",
        "completed_header": "{completed_count} von {issues_count} Punkten abgeschlossen",
        "customer": "Kunde",
        "date": "Startdatum (optional)",
        "delete_explanation": "Alle Punkte werden zusammen mit ihren Bildern und Dokumenten dauerhaft von der Plattform entfernt.",
        "description_title": "Beschreibung hinzufügen",
        "deselect_all": "Alle abwählen",
        "edit_multiple": "{count} Punktelisten bearbeiten",
        "hide_count": "Veröffentlichung der Punkte für 1 Einheit aufheben | Veröffentlichung der Punkte für {count} Einheiten aufheben",
        "hide_count_SUP": "Veröffentlichung der Punkte aufheben",
        "issue_list": "Punkteliste",
        "issue_lists": "Nachbetreuung",
        "issue_lists_all_projects": "Nachbetreuung, alle Projekte",
        "issues_count": "Punkte",
        "no_issues_to_export": "Keine Punkte zum Exportieren",
        "no_lists_completed": "Keine Listen abgeschlossen",
        "open_all": "Öffnen",
        "partners": "Partner",
        "pdf_generated_successfully": "PDF erfolgreich erstellt",
        "process_issues": "Liste zuweisen",
        "project_units_total": "{project_name} hat insgesamt {units_count_max} Einheiten",
        "publish_now": "Jetzt veröffentlichen?",
        "published_count": "Punkte für 1 Einheit veröffentlichen | Punkte für {count} Einheiten veröffentlichen",
        "published_count_SUP": "Punkte veröffentlichen",
        "save_explainer": "Die (zukünftigen) Punkte für Ihre Kunden sichtbar machen? Oder speichern und später veröffentlichen?",
        "selectOne": "Wählen Sie mindestens 1 Liste aus",
        "select_all": "Alle auswählen",
        "selected": "{selected} Liste ausgewählt. | {selected} Listen ausgewählt",
        "status": "Status",
        "step_1_info": "Z. B. vorläufige oder endgültige Abnahme, Punkte für Küche oder Bäder …",
        "step_1_title": "Welche Art von Punkteliste möchten Sie erstellen?",
        "step_2_subtitle": "Wählen Sie Ihr Projekt aus, um alle Einheiten auf einmal hinzuzufügen. Sie können später jederzeit weitere Einheiten hinzufügen.",
        "step_2_title": "Für welche Einheiten möchten Sie Punkte erfassen?",
        "tab_issue_list_documents": "Dokumente",
        "tab_issue_list_issues": "Punkte",
        "tab_issue_list_issues_customer": "Nachbetreuung",
        "tab_issue_list_tickets": "Konversationen",
        "tab_issues": "Alle Punkte",
        "tab_units": "Einheiten",
        "totalSelected": "Alle {total} Listen sind ausgewählt",
        "you_have_customer_issues": "Sie haben 1 unbearbeiteten Kundenpunkt | Sie haben {number} unbearbeitete Kundenpunkte"
      },
      "navigation": {
        "back_to_issue_lists": "Zurück zu den Punktelisten"
      },
      "placeholders": {
        "customers": {
          "new": {
            "subtitle": "Verfolgen Sie gemeldete Punkte",
            "title": "Alle Ihre Punkte werden hier angezeigt"
          }
        },
        "employees": {
          "new": {
            "subtitle": "Erstellen Sie Punkte für die der Liste zugeordneten Einheiten",
            "title": "Erstellen Sie Ihre erste Punkteliste"
          }
        },
        "partners": {
          "subtitle": "Sie werden benachrichtigt, wenn neue Punkte erstellt wurden",
          "title": "Ihnen wurden noch keine Punkte zugewiesen"
        }
      },
      "validation": {
        "name_taken_locale": "Dieser Name wird in dieser Sprache bereits verwendet",
        "need_name": "Name ist erforderlich"
      }
    }
  }
}
